import axios from "axios"

let store = undefined;

function useAxios (value) {
    store = value
}

axios.interceptors.request.use (
    (config) => {
        config.headers['Authorization'] = "Bearer " + store.state.sign['token']
        config.headers['Refresh-Token'] = store.state.sign['refreshToken']
        config.headers['screen'] = store.state.sign['screen']
        return config
    },
    (error) => {return Promise.reject(error)}
)

axios.interceptors.response.use(
    async (response) => {
        let accessToken = response.headers["access-token"]
        if (accessToken !== undefined && accessToken !== "") {
            store.commit("sign/setToken", accessToken)
            store.commit("sign/setSignedDate", new Date())
        }

        let refreshToken = response.headers["refresh-token"]
        if (refreshToken !== undefined && refreshToken !== "") {
            store.commit("sign/setRefreshToken", refreshToken)
        }
        return response
    },
    (err) => {
        return Promise.reject(err)
    }
)

axios.defaults.wichCredentials = true;

function get(url, config = {}, customHeaders) {
    // config.headers = {
    //     Authorization: "Bearer " + store.state.sign['token']
    //     , 'Refresh-Token': store.state.sign['refreshToken']
    //     , screen: store.state.sign['screen']
    // }

    if (!config.headers) {
        config.headers = {}
    }

    if (customHeaders) {
        for (const key in customHeaders) {
            config.headers[key] = customHeaders[key];
        }
    }

    return axios.get(url, config)
}

function post(url, contents, config = {headers: {}}) {
    // config.headers['Authorization'] = "Bearer " + store.state.sign['token']
    // config.headers['Refresh-Token'] = store.state.sign['refreshToken']
    // config.headers['screen'] = store.state.sign['screen']

    let res = axios.post(url, contents, config)
    return res
}

function put(url, contents, config = {headers: {}}) {
    // config.headers['Authorization'] = "Bearer " + store.state.sign['token']
    // config.headers['Refresh-Token'] = store.state.sign['refreshToken']
    // config.headers['screen'] = store.state.sign['screen']

    let res = axios.put(url, contents, config)
    return res
}

function patch (url, contents, config = {headers: {}}) {
    // config.headers['Authorization'] = "Bearer " + store.state.sign['token']
    // config.headers['Refresh-Token'] = store.state.sign['refreshToken']
    // config.headers['screen'] = store.state.sign['screen']

    let res = axios.patch(url, contents, config)
    return res
}

function delete_ (url, contents, headers) {
    const toContents = {
        // headers: {
        //     Authorization: "Bearer " + store.state.sign['token'],
        //     "Refresh-Token": store.state.sign['refreshToken'],
        //     screen: store.state.sign['screen']
        // },
        headers: {},
        data: contents,
    };

    if(headers){
        for (const key in headers) {
            toContents.headers[key] = headers[key];
        }
    }

    let res = axios.delete(url, toContents)
    return res
}

const axios_ = {
    $useAxios: useAxios,
    $get: get,
    $post: post,
    $put: put,
    $patch: patch,
    $delete: delete_
};

export default axios_;
